export default __webpack_public_path__ + "static/media/icon_picture.eb2d783c.svg";